import { useState, useEffect, useRef } from "react";
import '../components-css/case-study-detail.scss';
import { useParams, useNavigate } from 'react-router-dom';

const caseStudiesData = {
    "r3-business": {
        heroImage: "/r3banner1.png",
        heroTitle: "R3 BUSINESS SOLUTION",
        overview: {
            title: "CLIENT OBJECTIVE",
            websiteLabel: "SEO CASE STUDY",
            websiteUrl: "r3biz.com",
            websiteHref: "https://sedonainvesting.com",
            industry: "B2B Consulting",
            duration: "3+ Years",
            services: "SEO Strategy & Execution",
            paragraphs: [
                {
                    intro: "When r3biz partnered with us, their goals were clear:",
                    bullets: [
                        "Improve website usability so visitors could easily understand services and take action",
                        "Increase online visibility to strengthen brand recognition",
                        "Generate genuine inquiries and calls through the website"
                    ],
                    outro:
                        "They weren't looking for quick ranking wins. They wanted SEO to support long-term brand growth."
                }
            ],

            topKeywords: "Office Equipment Solutions San Diego, Managed print services provider San Diego, Managed Print Services San Diego, Business Copier san diego, business copier solutions San Diego"
        },
        seoProcess: [
            "Starting Point",
            "Strategy & Execution",
            "Ongoing SEO",
            "Adapting Through Google Updates",
            "Decision-Making & Continuous Optimization",
            "Results & Business Impact",
            "Why This Became a Long-Term Partnership",
            "Key Takeaway"
        ],
        sections: [
            {
                id: "starting-point",
                title: "Starting Point",
                layout: "default",
                content: {
                    intro: "At the beginning, the website had potential but lacked:",
                    subheading: "",
                    bullets: [
                        "Strong visibility for relevant business keywords",
                        "Clear user flow that encouraged inquiries",
                        "Consistent organic presence in a competitive market"
                    ],
                    closing: "SEO needed to work hand-in-hand with user experience and branding."
                }
            },
            {
                id: "strategy-execution",
                title: "Strategy & Execution",
                layout: "beige",
                content: {
                    intro: "We approached this engagement in phases rather than a fixed checklist.",
                    subheading: 'Foundation',
                    bullets: [
                        "Strong visibility for relevant business keywords",
                        "Clear user flow that encouraged inquiries",
                        "Consistent organic presence in a competitive market"
                    ],
                }
            },
            {
                id: "ongoing-seo",
                title: "Ongoing SEO",
                layout: "default",
                content: {
                    intro: "",
                    subheading: "",
                    bullets: [
                        "Continuous competitor and market research",
                        "Content and page-level optimizations based on search behavior",
                        "Authority building tailored to the industry and audience"
                    ],
                    closing: "Every step was aligned with how real users search and make decisions."
                }
            },
            {
                id: "adapting-through-google-updates",
                title: "Adapting Through Google Updates",
                layout: "beige",
                content: {
                    intro: "Over the past three years, multiple major Google algorithm updates impacted search results across industries.",
                    subheading: "",
                    bulletheading1: "There were periods where:",
                    bullets: [
                        "Rankings and traffic temporarily dipped after updates",
                        "Website changes required SEO strategy adjustments"
                    ],
                    bulletheading2: "Instead of reacting impulsively, we:",
                    bullets2: [
                        "Closely monitored performance signals",
                        "Identified what changed and why",
                        "Refined content, structure, and keyword focus",
                        "Recovered and stabilized results over time"
                    ],
                    closing: "This adaptability played a key role in maintaining consistent visibility."
                }
            },
            {
                id: "decision-making-continuous-optimization",
                title: "Decision-Making & Continuous Optimization",
                layout: "default",
                content: {
                    intro: "SEO is never static.",
                    subheading: "",
                    bulletheading1: "Due to factors like:",
                    bullets: [
                        "Google updates",
                        "Ongoing website enhancements",
                        "Shifts in competitor strategies"
                    ],
                    bulletheading2: "We regularly revisited and adjusted our approach. All decisions were driven by:",
                    bullets2: [
                        "Data and performance trends",
                        "Market and competitor insights",
                        "Business relevance, not assumptions"
                    ],
                    closing: "This ensured SEO stayed aligned with r3biz's evolving goals."
                }
            },
        ],
        results: {
            id: "results",
            title: "Results & Business Impact",
            content: {
                intro: "Over time, SEO became a reliable growth channel rather than an experiment.",
                subheading: "Key outcomes:",
                bullets: [
                    "Improved visibility for core business services",
                    "Stronger brand recognition through organic search",
                    "Consistent inbound inquiries via the website",
                    "A stable SEO foundation that continues to perform"
                ],
                closing: "Results were built gradually and sustained, not short-lived spikes.",
                chartImage: "/r3result.png"
            }
        },
        imageWithContentLeft: {
            id: "long-term-partnership",
            title: "Why This Became a Long-Term Partnership",
            layout: "image-right",
            content: {
                image: "/r3left.png",
                intro: "",
                subheading: "The engagement continued for over three years because of:",
                bullets: [
                    "Transparent communication and clear reporting",
                    "Regular performance reviews and weekly calls",
                    "Honest discussions during both growth and downturns",
                    "A shared focus on long-term value, not short-term metrics"
                ],
                closing: "SEO worked because it was treated as a partnership, not a monthly task.",
                closingBold: ""
            }
        },
        imageWithContentRight: {
            id: "key-takeway",
            title: "Key Takeaway",
            layout: "image-right",
            content: {
                image: "/r3right.png",
                intro: "",
                subheading: "This case study reflects how SEO delivers the best results when:",
                bullets: [
                    "Strategies evolve with search engines and markets",
                    "Decisions are data-backed",
                    "Consistency is prioritized over shortcuts"
                ],
                closing: "",
                closingBold: "Long-term SEO doesn't just improve rankings. It builds a durable digital presence."
            }
        },
        testimonial: {
            quote: "OMKA TECH handled our website SEO with a clear strategy and professional execution from start to finish. The team understood our business and industry requirements and implemented targeted keyword optimization, technical improvements, and content enhancements effectively. Communication was consistent, reports were transparent, and progress was measurable month after month. We have seen steady growth in our search rankings, organic traffic, and quality inquiries without relying on paid ads. We consider OMKA TECH a reliable digital growth partner for our ongoing and future marketing initiatives.",
            name: "RON PUTMAN",
            role: "VP of Operations",
            avatar: "/r3clientlogo.png"
        }
    },
    "sedona-investing": {
        heroImage: "/sedonabanner.png",
        heroTitle: "SEDONA INVESTING",
        overview: {
            title: "OVERVIEW SEDONA INVESTING",
            websiteLabel: "SEO CASE STUDY",
            websiteUrl: "SedonaInvesting.com",
            websiteHref: "https://sedonainvesting.com",
            industry: "Real Estate",
            duration: "4+ Years",
            services: "SEO Strategy & Execution",
            paragraphs: [
                `SedonaInvesting.com operates in one of the most competitive real estate markets in Arizona. The client understands SEO, tracks rankings closely, and sets high standards. When he first engaged us, it was on a strict three-month, month-to-month basis.`,
                `The mandate was direct: compete for the most searched real estate keywords and secure top positions, not secondary placements.`,
                `More than four years later, the partnership continues.`
            ],
            topKeywords: "Properties and investments Sedona, Investment real estate Sedona, Luxury and Investment Specialist Sedona, Sedona cash flow investments, Sedona property investment"
        },
        seoProcess: [
            "The Initial Challenge",
            "Strategic Approach",
            "Navigating Google Algorithm Updates",
            "Website Redesign & Ranking Recovery",
            "Results Over Time",
            "Why the Engagement Continued",
            "Reporting, Communication & Project Oversight"
        ],
        sections: [
            {
                id: "initial-challenge",
                title: "The Initial Challenge",
                layout: "default",
                content: {
                    intro: "The Sedona real estate space is saturated with established brokerages, national listing platforms, and high-authority domains. Ranking for high-traffic keywords requires more than surface-level optimization.",
                    subheading: "At the outset, the website needed:",
                    bullets: [
                        "Stronger positioning for competitive transactional keywords",
                        "Better consolidation of authority across key landing pages",
                        "A structured plan to outperform long-standing competitors"
                    ],
                    closing: "The objective was not incremental improvement. It was measurable dominance in core search terms that drive serious buyers."
                }
            },
            {
                id: "strategic-approach",
                title: "Strategic Approach",
                layout: "beige",
                content: {
                    intro: "Given the client's expectations, our strategy centered on precision and sustained authority building.",
                    subsections: [
                        {
                            heading: "Competitive Intelligence",
                            text: "We conducted a detailed competitor audit to understand content depth, backlink strength, page structure, and ranking patterns. This allowed us to identify gaps rather than replicate what others were doing."
                        },
                        {
                            heading: "Keyword Segmentation by Intent",
                            text: "Instead of focusing solely on volume, we mapped keywords by buyer intent. High-traffic phrases were prioritized, but always aligned with conversion potential."
                        },
                        {
                            heading: "On-Page & Structural Strengthening",
                            text: "Core service and property-related pages were enhanced for depth, clarity, and internal authority flow. Internal linking was restructured to strengthen priority pages and distribute ranking power strategically."
                        },
                        {
                            heading: "Authority Development",
                            text: "Link acquisition focused on relevance and credibility within the real estate ecosystem. Growth was steady and defensible, avoiding artificial spikes."
                        }
                    ]
                }
            },
            {
                id: "algorithm-updates",
                title: "Navigating Google Algorithm Updates",
                layout: "default",
                content: {
                    intro: "Over four years, multiple major algorithm updates impacted the real estate sector. There were periods where rankings fluctuated, as is common in competitive niches.",
                    subheading: "Our response followed a structured process:",
                    bullets: [
                        "Immediate performance analysis at page level",
                        "Identification of ranking pattern shifts",
                        "Content refinement where depth or intent alignment required improvement",
                        "Reinforcement of authority signals"
                    ],
                    closing: "Temporary declines were addressed methodically. Rankings were restored and, in several instances, strengthened beyond prior positions."
                }
            },
            {
                id: "website-redesign",
                title: "Website Redesign & Ranking Recovery",
                layout: "beige",
                content: {
                    intro: "A full website redesign was initiated by the client. Site migrations carry significant SEO risk, particularly in competitive markets where ranking loss can result in immediate revenue impact.",
                    subheading: "Our role during the redesign included:",
                    bullets: [
                        "Pre-migration SEO audit and benchmark documentation",
                        "URL structure planning to preserve ranking equity",
                        "301 redirect mapping for all existing indexed pages",
                        "Post-launch monitoring and rapid response to ranking shifts",
                        "Internal link recalibration to restore authority pathways"
                    ],
                    closing: "Within a defined recovery period, visibility returned and stabilized. Organic growth resumed without compromising long-term momentum."
                }
            },
        ],
        results: {
            id: "results",
            title: "Results Over Time",
            content: {
                intro: "Across four years, SEO transitioned from a trial initiative to a dependable acquisition channel.",
                subheading: "The sustained outcomes include:",
                bullets: [
                    "Strong rankings for competitive, high-traffic real estate keywords",
                    "Consistent organic visibility in a saturated market",
                    "Reliable inbound traffic from search",
                    "Long-term retention of priority keyword positions"
                ],
                closing: "Performance has not been built on short bursts. It has been maintained through continuous optimization and disciplined execution.",
                chartImage: "/sedonaresult.png"
            }
        },
        imageWithContentLeft: {
            id: "engagement-continued",
            title: "Why the Engagement Continued",
            layout: "image-left",
            content: {
                image: "/sedonaleft.png",
                intro: "The original three-month trial extended because results were measurable and consistent.",
                subheading: "The partnership has endured due to:",
                bullets: [
                    "Transparent, performance-driven reporting",
                    "Direct communication and alignment on ranking expectations",
                    "Structured recovery during volatility",
                    "Strategic adjustments aligned with algorithm shifts and site evolution"
                ],
                closing: "SEO for SedonaInvesting.com has remained performance-focused, accountable, and adaptable.",
                closingBold: "This engagement represents disciplined SEO execution under high expectations, maintained over multiple years without disruption to growth trajectory."
            }
        },
        imageWithContentRight: {
            id: "project-oversight",
            title: "Reporting, Communication & Project Oversight",
            layout: "image-right",
            content: {
                image: "/sedonaright.png",
                intro: "Performance transparency has been a core component of this engagement. We provide structured bi-weekly and monthly reports that present clear performance comparisons across keyword rankings, organic traffic trends, and page-level movement. Reporting is designed to highlight not only growth, but also fluctuations, competitive shifts, and recovery patterns when applicable. This ensures decisions are based on data rather than assumptions.",
                subheading: "In addition, a dedicated Project Manager is assigned to the account. The Project Manager:",
                bullets: [
                    "Conducts regular performance meetings",
                    "Shares reports with contextual explanations",
                    "Tracks deliverables and implementation timelines",
                    "Acts as the single point of contact between the client and the SEO team"
                ],
                closing: "",
                closingBold: "This structure maintains accountability, eliminates communication gaps, and ensures strategic alignment throughout the engagement."
            }
        },
        testimonial: {
            quote: "OMKA TECH brought structure and direction to our digital growth efforts. Their SEO strategy was not just technical but aligned closely with our investor-focused positioning. They identified key search opportunities within our niche and optimized the website with precision. The improvements in visibility and engagement were gradual but consistent. We particularly valued their proactive communication and strategic clarity. OMKA TECH has played a key role in strengthening our organic presence online.",
            name: "CHAD MCMAHAN",
            role: "Sedona Local Expert",
            avatar: "/sedonaclient.png"
        }
    },
    "calhoun-tech": {
        heroImage: "/calhounbanner.png",
        heroTitle: "CALHOUN TECHNOLOGIES",
        overview: {
            title: "EXECUTIVE SUMMARY",
            websiteLabel: "SEO CASE STUDY",
            websiteUrl: "calhountechnologies.com/",
            websiteHref: "https://calhountechnologies.com/",
            industry: "Industrial Electronic Components",
            duration: "2+ Years",
            services: "E-Commerce Development, SEO, Paid Ads, Amazon Setup",
            paragraphs: [
                `Calhoun Technologies operated a long-standing website housing millions of electronic components and generating substantial traffic. The objective was to build a modern, RFQ-driven e-commerce platform with a streamlined product catalog while preserving and gradually transferring traffic from the legacy site.`,
                `This was not a simple website build. It required infrastructure planning, controlled traffic transition, search visibility protection, and sustained lead generation from the outset.`
            ],
            topKeywords: "NVH100TCGPU-KIT H100 Graphic Card, Dell 0K3NHD RISER BOARD, Tesla H100 80GB NVIDIA Deep Learning GPU, Dell 760W AC POWER SUPPLY, Dell T5600 Memory Module Baffle Air Shroud"
        },
        seoProcess: [
            "The Business Challenge",
            "Phase 1: E-Commerce Architecture & Product Deployment",
            "Phase 2: Traffic Acquisition & RFQ Growth",
            "Navigating Growth Volatility",
            "Reporting, Governance & Operational Oversight",
            "Results & Business Impact",
            "Scope of Engagement"
        ],
        sections: [
            {
                id: "business-challenge",
                title: "The Business Challenge",
                layout: "default",
                content: {
                    intro: "The legacy website had scale and historical authority, but it lacked a structured e-commerce framework designed specifically for RFQ generation.",
                    subheading: "The new platform needed to:",
                    bullets: [
                        "Launch with a controlled catalog of approximately 10,000 products",
                        "Support gradual product expansion",
                        "Avoid loss of existing search visibility",
                        "Begin generating RFQs immediately",
                        "Compete within a technically complex industrial niche"
                    ],
                    closing: "Replacing or supplementing a high-traffic site introduces measurable SEO risk. Mitigation required disciplined execution."
                }
            },
            {
                id: "product-deployment",
                title: "Phase 1: E-Commerce Architecture & Product Deployment",
                layout: "beige",
                content: {
                    intro: "We developed a scalable e-commerce portal structured around industrial buyer behavior rather than standard retail checkout models.",
                    subheading: 'Key initiatives included:',
                    bullets: [
                        "Deployment of a structured, crawl-efficient product architecture",
                        "Bulk upload and optimization of ~10,000 products",
                        "Image refinement and standardization",
                        "Categorization for both usability and indexation efficiency",
                        "RFQ-focused conversion pathways integrated across product pages"
                    ],
                    closing: `In parallel, we established and optimized the client's Amazon seller presence, expanding visibility beyond owned channels and reinforcing brand authority across marketplaces. The platform launched with both operational readiness and search compatibility embedded at its foundation.`
                }
            },
            {
                id: "rfq-growth",
                title: "Phase 2: Traffic Acquisition & RFQ Growth",
                layout: "default",
                content: {
                    intro: "Following launch, the strategic focus shifted to controlled traffic growth and measurable inquiry generation.",
                    subheading: "Our integrated marketing execution included:",
                    bullets: [
                        "Progressive SEO targeting over 100 high-intent industry keywords",
                        "On-page optimization at product and category levels",
                        "Technical audits to maintain indexing stability",
                        "Google Ads campaigns focused on transactional search queries",
                        "Social media support to enhance brand exposure within the sector"
                    ],
                    closing: "Traffic was scaled methodically. The objective was sustainable authority development rather than short-term spikes. From the first month post-launch, RFQs began to flow."
                }
            },
            {
                id: "navigating-growth",
                title: "Navigating Growth Volatility",
                layout: "beige",
                content: {
                    intro: "As expected with a new e-commerce domain:",
                    subheading: "",
                    bulletheading1: "",
                    bullets: [
                        "Organic traction required consistent reinforcement",
                        "Algorithm updates introduced periodic ranking fluctuations",
                        "Authority had to be rebuilt page by page"
                    ],
                    bulletheading2: "We maintained structured monitoring and recalibrated keyword, content, and internal linking strategies as performance data evolved.",
                    closing: "Adjustments were data-led, ensuring recovery and forward movement rather than reactive changes."
                }
            },
        ],
        results: {
            id: "results",
            title: "Results & Business Impact",
            content: {
                intro: "Over two years, the new platform transitioned from a supplemental initiative to a primary revenue contributor.",
                subheading: "Key outcomes include:",
                bullets: [
                    "Gradual restoration and expansion of organic traffic",
                    "Keyword visibility growth across targeted industrial terms",
                    "Consistent RFQ generation from early launch stages",
                    "Traffic levels approaching — and in key segments surpassing — the legacy platform",
                    "Increased share of business originating from the new e-commerce site"
                ],
                closing: "The platform now operates as a stable acquisition channel supported by continuous optimization.",
                chartImage: "/calhounresult.png"
            }
        },
        imageWithContentLeft: {
            id: "long-term-partnership",
            title: "Scope of Engagement",
            layout: "image-right",
            content: {
                image: "/calhounleft.png",
                intro: "",
                subheading: "This partnership encompasses end-to-end digital execution:",
                bullets: [
                    "E-commerce design and development",
                    "Product uploads and optimization",
                    "Content structuring",
                    "Amazon marketplace setup",
                    "SEO implementation and scaling",
                    "Paid advertising management",
                    "Social media marketing"
                ],
                closing: "Execution remains unified under a single objective: sustained RFQ growth and long-term digital scalability.",
                closingBold: ""
            }
        },
        imageWithContentRight: {
            id: "key-takeway",
            title: "Reporting, Governance & Operational Oversight",
            layout: "image-right",
            content: {
                image: "/calhounright.png",
                intro: "Transparency has been central to this engagement.",
                subheading: "We provide bi-weekly and monthly performance reports detailing:",
                bullets: [
                    "Keyword ranking progression",
                    "Organic traffic trends",
                    "RFQ growth metrics",
                    "Paid campaign performance comparisons",
                    "Page-level visibility movement",
                ],
                bulletsBottom: 'Each report contextualizes performance changes, whether growth or fluctuation, allowing strategic decisions to be grounded in measurable data.',
                bullet2Heading: 'A dedicated Project Manager oversees the account, responsible for:',
                bullets2: [
                    "Coordinating development and marketing deliverables",
                    "Conducting structured review meetings",
                    "Translating technical SEO insights into business-level implications",
                    "Serving as the single point of contact between the client and our execution teams"
                ],
                closing: "",
                closingBold: "Long-term SEO doesn't just improve rankings. It builds a durable digital presence. This structure ensures alignment across development, SEO, and marketing without communication gaps."
            }
        },
        testimonial: {
            quote: "Working with OMKA TECH on our e-commerce development, SEO, paid ads, and Amazon setup has been a great experience for Calhoun Technologies. They built a scalable online store aligned with our business goals while strengthening our search visibility through well-planned SEO strategies. Their paid campaigns brought in quality traffic and conversions, and the Amazon setup process was handled smoothly from start to finish. We appreciate their clear communication and structured execution, and we see them as a dependable partner in our ongoing digital growth.",
            name: "NOEL SALISBURY",
            role: "Company Owner",
            avatar: "/calhounclient.png"
        }
    },
    "purosurf": {
        heroImage: "/purosurfImg.png",
        heroTitle: "PURO SURF",
        overview: {
            title: "EXECUTIVE SUMMARY",
            websiteLabel: "SEO CASE STUDY",
            websiteUrl: "purosurf.com/",
            websiteHref: "https://www.purosurf.com/",
            industry: "Hospitality & Surf Resort",
            duration: "1+ Years (Ongoing)",
            services: "Custom Development, SEO Migration, SEO, Paid Ads, Social Media, AEO",
            paragraphs: [
                `Puro Surf is a premium surf resort and performance academy located in El Zonte, El Salvador. The brand had strong market presence and existing search visibility, but its legacy website was limiting operational efficiency and digital growth.`,
                `The client approached us initially for a website transformation. The broader objective evolved into a full digital growth mandate covering website development, SEO migration, paid advertising, social media, and Answer Engine Optimization (AEO).`,
                `The result was a seamless platform transition with traffic stability, followed by measurable year-over-year growth of approximately 70%.`
            ],
            topKeywords: "Surf Resort El Salvador, El Salvador Surf Resort, Surf Resort El Salvador, El Salvador Surf Resort, Covana Kitchen Restaurant, El Salvador Surf Trip, Remote work surf El Salvador, Surf Camp El Salvador, Surf video coaching El Salvador, Live Surf Cam El Salvador"
        },
        seoProcess: [
            "The Initial Challenge",
            "Phase 1: Platform Architecture & Custom Development",
            "Phase 2: SEO Migration & Traffic Protection",
            "Phase 3: Growth Acceleration — SEO, Paid & Social",
            "Performance & Year-over-Year Growth",
            "Managing Ongoing Algorithm Volatility"
        ],
        sections: [
            {
                id: "initial-challenge",
                title: "The Initial Challenge",
                layout: "default",
                content: {
                    intro: "The legacy website had scale and historical authority, but it lacked a structured e-commerce framework designed specifically for RFQ generation.",
                    subsections: [
                        {
                            heading: "1. No CMS Flexibility",
                            text: "Even minor content updates required developer intervention, increasing operational costs and slowing marketing execution."
                        },
                        {
                            heading: "2. Outdated Design & UX Constraints",
                            text: "The visual presentation no longer reflected the premium positioning of the brand."
                        },
                        {
                            heading: "3. SEO Risk During Migration",
                            text: "The old domain had accumulated backlinks, authority, and traffic through prior SEO efforts. A redesign without structured migration could have caused significant ranking loss."
                        }
                    ],
                    closing: "The new platform needed to be modern, scalable, visually refined, and technically strong enough to preserve and enhance search performance"
                }
            },
            {
                id: "custom-deployment",
                title: "Phase 1: Platform Architecture & Custom Development",
                layout: "beige",
                content: {
                    intro: "We selected WordPress for its content flexibility, but the design and backend requirements exceeded what standard themes or plugins could deliver.",
                    subheading: 'The solution involved:',
                    bullets: [
                        "WordPress CMS integration for content control",
                        "Custom-coded modules to meet structural and booking requirements",
                        "Integration with the resort's room booking engine",
                        "Backend architecture designed for scalability"
                    ],
                    bulletheading2: "The client's project manager maintained precise design expectations. To ensure fidelity to the brand vision, we assigned a dedicated UI/UX specialist who:",
                    bullets2: [
                        "Designed the full interface in Figma",
                        "Established structured user journeys",
                        "Defined mobile-first responsiveness",
                        "Collaborated directly with development to ensure pixel-level accuracy"
                    ],
                    closing: `The result was a platform that balanced design precision with backend flexibility.`
                }
            },
            {
                id: "traffic-protection",
                title: "Phase 2: SEO Migration & Traffic Protection",
                layout: "default",
                content: {
                    intro: "Once stability was confirmed, focus shifted to expansion.",
                    subheading: "Our multi-channel strategy included:",
                    bullets: [
                        "Complete URL mapping from old to new architecture",
                        "301 redirect validation across all key pages",
                        "Backlink preservation strategy",
                        "Search Console and indexing monitoring",
                        "Crawl audits pre- and post-launch"
                    ],
                    closing: "There was a minor, short-term traffic dip immediately after launch, which is typical during structural transitions. Within one month, traffic stabilized and returned to expected levels. The SEO authority was preserved."
                }
            },
            {
                id: "growth-accelaration",
                title: "Phase 3: Growth Acceleration — SEO, Paid & Social",
                layout: "beige",
                content: {
                    intro: "Phase 3: Growth Acceleration — SEO, Paid & Social",
                    subheading: "Our multi-channel strategy included:",
                    bulletheading1: "",
                    bullets: [
                        "Advanced SEO targeting high-intent hospitality and surf-related keywords",
                        "Technical optimization to strengthen crawl depth and page speed",
                        "Structured content expansion aligned with search behavior",
                        "Google Ads campaigns focused on booking intent",
                        "Social media marketing to reinforce brand positioning"
                    ],
                    closing: "In parallel, we implemented Answer Engine Optimization (AEO) to position the brand within evolving search experiences, including structured content aligned with question-based queries."
                }
            },
            {
                id: "performance-growth",
                title: "Performance & Year-over-Year Growth",
                layout: "default",
                content: {
                    intro: "When comparing performance against the previous year:",
                    bullets: [
                        "Organic visibility expanded across competitive keywords",
                        "Booking-related search queries strengthened",
                        "Traffic increased by approximately 70% year-over-year",
                        "Direct and paid channels supported higher booking intent"
                    ],
                    closing: "Growth was not isolated to one channel. It reflected coordinated digital execution."
                }
            },
            {
                id: "algorithm-volatility",
                title: "Managing Ongoing Algorithm Volatility",
                layout: "beige",
                content: {
                    intro: "Throughout the engagement, multiple Google algorithm updates impacted hospitality and travel sectors.",
                    subheading: "As with previous case studies, we maintained:",
                    bullets: [
                        "Continuous monitoring of keyword clusters",
                        "Content refinement aligned with evolving ranking factors",
                        "Authority reinforcement across high-performing pages",
                        "Technical recalibration where required"
                    ],
                    closing: "Temporary fluctuations were addressed methodically, preserving long-term ranking strength."
                }
            },
        ],
        results: {
            id: "results",
            title: "Reporting, Communication & Governance",
            content: {
                intro: "This partnership encompasses end-to-end digital execution:",
                bullets: [
                    "Conducts structured review meetings",
                    "Oversees development and marketing coordination",
                    "Acts as the single point of contact",
                    "Ensures timely execution of strategic updates"
                ],
                closing: "This framework ensures alignment between business objectives and digital performance.",
                chartImage: "/purosurfresult.png"
            }
        },
        imageWithContentLeft: {
            id: "long-term-partnership",
            title: "Each account is managed by a dedicated Project Manager who:",
            layout: "image-right",
            content: {
                image: "/purosurfleft.png",
                intro: "This partnership encompasses end-to-end digital execution:",
                bullets: [
                    "Conducts structured review meetings",
                    "Oversees development and marketing coordination",
                    "Acts as the single point of contact",
                    "Ensures timely execution of strategic updates"
                ],
                closing: "This framework ensures alignment between business objectives and digital performance.",
                closingBold: ""
            }
        },
        testimonial: {
            quote: "Our experience with OMKA TECH across custom development, SEO migration, SEO, paid ads, social media, and AEO has been extremely positive for Purosurf. They handled the SEO migration carefully while enhancing site performance, improved our search visibility through strategic optimization, and strengthened our brand presence with targeted ads and social media efforts. Their AEO approach further helped us reach the right audience more effectively. We value their professionalism, clear communication, and data-backed execution throughout the project.",
            name: "RODRIGO LARIOS",
            role: "General Manager",
            avatar: "/purosurfclient.png"
        }
    },
    "novfeel": {
        heroImage: "/novfeelimg.png",
        heroTitle: "NOVFEEL",
        overview: {
            title: "EXECUTIVE SUMMARY",
            websiteLabel: "SEO CASE STUDY",
            websiteUrl: "novfeel.com/",
            websiteHref: "https://www.novfeel.com/",
            industry: "Stainless Steel Drinkware Manufacturer & OEM/ODM Supplier",
            duration: "1 Year (Ongoing)",
            services: "AI-First Digital Marketing, LLMO, SEO, Market Targeting",
            paragraphs: [
                `NovFeel is a China-based manufacturer and global supplier of stainless steel drinkware — including insulated bottles, tumblers, corporate gift sets, and branded promotional items — serving distributors and brands in Europe, North America, Asia, and other export markets.`,
                `Before partnering with us, the client had engaged multiple digital agencies without achieving meaningful results. The core issue was not effort, but audience targeting: previous strategies failed to reach the right buyers, resulting in high spend with little return.`,
                `Over the past year, we implemented an AI-first digital marketing strategy anchored by Large Language Model Optimization (LLMO) and disciplined SEO. This approach helped NovFeel connect with the correct customer segments, significantly improve organic visibility, and attract qualified inquiries from relevant global markets.`
            ],
            topKeywords: "Wine Utensils Manufacturer & Supplier, Sector Hip Flask-Wine Utensils, Insulated Octagon Water Bottle, Six Sides Hip Flask, Electroplated Color Hip Flask, Cork Base Cola Shaped Bottle"
        },
        seoProcess: [
            "The Initial Challenge",
            "Strategic Approach",
            "SEO Execution",
            "Connecting With the Right Market",
            "Reporting & Accountability",
            "Results & Business Impact",
            "Why This Engagement Succeeded",
            "Scope of Engagement"
        ],
        sections: [
            {
                id: "initial-challenge",
                title: "The Initial Challenge",
                layout: "default",
                content: {
                    intro: "NovFeel faced persistent challenges:",
                    bullets: [
                        "Engagement with multiple agencies that failed to produce results",
                        "Misaligned audience targeting that drove irrelevant traffic",
                        "Lack of clarity in buyer intent and market behavior",
                        "An underperforming digital presence despite strong product and export capabilities"
                    ],
                    closing: "The underlying issue was a strategic mismatch between audience needs and digital execution."
                }
            },
            {
                id: "strategic-approach",
                title: "Strategic Approach",
                layout: "beige",
                content: {
                    intro: "AI-First Audience Understanding",
                    subheading: "The turning point in this engagement was deeply understanding NovFeel's market — who its buyers are, how they search, and what language they use when evaluating drinkware OEM/ODM solutions. This industry requires precise alignment between product language and search intent, especially for B2B buyers seeking custom solutions.",
                    bulletheading1: "LLMO played a central role by:",
                    bullets: [
                        "Mapping semantic search behavior for OEM/ODM buyer queries",
                        "Expanding keyword sets based on real buyer vocabulary",
                        "Aligning content with transaction-oriented intent rather than generic interest"
                    ],
                    closing: `This ensured that SEO efforts were not just about traffic, but about relevance.`
                }
            },
            {
                id: "seo-execution",
                title: "SEO Execution",
                layout: "default",
                content: {
                    intro: "With LLMO insights in place, we implemented a tailored SEO strategy:",
                    bullets: [
                        "Precision keyword targeting based on buyer intent",
                        "On-page optimization for product categories and OEM service pages",
                        "Technical SEO to ensure crawlability and indexation stability",
                        "Internal linking strategy focused on driving authority to core conversion pages",
                        "Content structuring around how international buyers search for drinkware solutions"
                    ],
                    closing: "Instead of chasing broad visibility, the focus was on search outcomes that influence business inquiries."
                }
            },
            {
                id: "right-market",
                title: "Connecting With the Right Market",
                layout: "beige",
                content: {
                    intro: "Previous partners targeted broad audience clusters that did not align with NovFeel's buyers — promotional product buyers, private label brands, corporate purchasing teams, and international distributors. We shifted focus to:",
                    bullets: [
                        "Export-oriented B2B segments",
                        "Industry-specific search queries with high commercial intent",
                        "Language patterns and search behaviors unique to target markets"
                    ],
                    closing: "This targeted approach drove qualified traffic and inquiry growth rather than generic volume."
                }
            },
            {
                id: "reporting-accountability",
                title: "Reporting & Accountability",
                layout: "default",
                content: {
                    intro: "Performance transparency has been central to the engagement. We provide:",
                    bullets: [
                        "Bi-weekly and monthly performance reports",
                        "Keyword ranking trends aligned with buyer segments",
                        "Organic visibility movement and market comparison insights",
                        "Contextual analysis of customer engagement and inquiry patterns"
                    ],
                    closing: "A dedicated Project Manager oversees coordination, ensuring strategic alignment between execution and business goals, and serving as the single point of contact for the client."
                }
            },
        ],
        results: {
            id: "results",
            title: "Results & Business Impact",
            content: {
                subheading: "Within one year of implementation:",
                bullets: [
                    "Organic visibility improved across high-intent, commercially relevant keyword clusters",
                    "Website traffic increasingly reflected buyer intent from target markets",
                    "The client began receiving qualified inquiries aligned with OEM/ODM objectives",
                    "Search presence strengthened in core international regions"
                ],
                closing: "Importantly, performance improvements were measurable against business goals rather than generic traffic metrics.",
                chartImage: "/novfeelresult.png"
            }
        },
        imageWithContentLeft: {
            id: "long-term-partnership",
            title: "Why This Engagement Succeeded",
            layout: "image-right",
            content: {
                image: "/novfeelleft.png",
                intro: "",
                subheading: "The success of the NovFeel partnership rests on:",
                bullets: [
                    "Deep market and industry understanding",
                    "Precision audience targeting based on behavior and intent",
                    "AI-first optimization that aligned search with buyer language",
                    "Disciplined SEO execution and ongoing refinement",
                    "Structured reporting and strategic governance"
                ],
                closing: "This case demonstrates that digital performance is not just about visibility but about alignment — targeting the right audience with the right message.",
                closingBold: ""
            }
        },
        imageWithContentRight: {
            id: "key-takeway",
            title: "Scope of Engagement",
            layout: "image-right",
            content: {
                image: "/novfeelright.png",
                intro: "",
                subheading: "The partnership spans:",
                bullets: [
                    "AI-First Digital Marketing Strategy",
                    "Large Language Model Optimization (LLMO)",
                    "Precision SEO Execution",
                    "Continuous Audience & Keyword Optimization",
                    "Structured Performance Reporting",
                    "Dedicated Project Management"
                ],
                closing: "",
                closingBold: "Execution remains focused on measurable business outcomes rather than short-term search metrics."
            }
        },
        testimonial: {
            quote: "We collaborated with OMKA TECH to enhance Novfeel's digital growth through their AI-First Digital Marketing approach, and the experience has been highly impactful. Their team combined strategic SEO, LLM optimization, and precise market targeting to position our brand more effectively in front of the right audience. They demonstrated strong technical expertise while ensuring every strategy aligned with our business objectives. What truly stood out was their structured execution, transparent reporting, and data-driven decision-making. Instead of focusing only on traffic, they prioritized quality visibility and meaningful engagement. We have seen measurable improvements in our online presence and brand positioning, and we consider OMKA TECH a trusted partner for our continued digital expansion.",
            name: "J.C JU",
            role: "Company Owner",
            avatar: "/novfeelclient.png"
        }
    },
    "uprivate-label": {
        heroImage: "/uprivateimg.png",
        heroTitle: "U PRIVATE",
        overview: {
            title: "EXECUTIVE SUMMARY",
            websiteLabel: "SEO CASE STUDY",
            websiteUrl: "uprivatelabel.com/",
            websiteHref: "https://www.uprivatelabel.com/",
            industry: "Private Label Beauty & Skincare",
            duration: "4+ Year",
            services: "Shopify Development, SEO, SMO",
            paragraphs: [
                `UPrivateLabel.com is a private label beauty brand serving entrepreneurs and businesses seeking customized skincare and cosmetic products. The engagement began with a foundational requirement: build a fully functional e-commerce platform capable of supporting product sales and brand positioning from day one.`,
                `Over four years later, the relationship continues as a long-term digital growth partnership covering Shopify development, branding support, SEO, and social media optimization. The result has been sustained organic growth, stable traffic performance, and consistent order generation through search.`,
            ],
            topKeywords: "Skin Loving Bath & Body Oil, U private label hair products, Blissful Hair and Body Oil, U Private label hair care manufacturer, Private label Peppermint soothing Oil"
        },
        seoProcess: [
            "The Initial Requirement",
            "Phase 1: Shopify Development & Brand Foundation",
            "Phase 2: SEO & Organic Growth Strategy",
            "Managing Algorithm Volatility",
            "Social Media Optimization (SMO)",
            "Performance & Business Impact",
            "Reporting & Account Governance",
        ],
        sections: [
            {
                id: "initial-requirement",
                title: "The Initial Requirement",
                layout: "default",
                content: {
                    intro: "When the client approached us, the primary objective was clear:",
                    bullets: [
                        "Develop a professional Shopify-based e-commerce store",
                        "Create strong visual product labeling aligned with brand identity",
                        "Establish a scalable online presence capable of driving direct sales"
                    ],
                    closing: "The business needed more than a store. It required a foundation that could support long-term organic visibility and recurring orders."
                }
            },
            {
                id: "brand-foundation",
                title: "Phase 1: Shopify Development & Brand Foundation",
                layout: "beige",
                content: {
                    intro: "We designed and deployed a fully structured Shopify e-commerce portal tailored to the beauty industry.",
                    subheading: 'Key execution elements included:',
                    bullets: [
                        "Shopify store architecture optimized for scalability",
                        "Structured product categorization for crawl efficiency",
                        "Clean, conversion-focused user experience",
                        "Integration of essential e-commerce functionalities",
                        "Assistance with product label design to strengthen brand positioning"
                    ],
                    closing: `The platform was built to support both direct consumer sales and wholesale inquiries while maintaining brand consistency.`
                }
            },
            {
                id: "organic-growth",
                title: "Phase 2: SEO & Organic Growth Strategy",
                layout: "default",
                content: {
                    intro: "Once the platform was operational, the focus shifted to long-term visibility.",
                    subheading: "Our SEO approach included:",
                    bullets: [
                        "Keyword research aligned with private label and product-intent searches",
                        "On-page optimization across product and collection pages",
                        "Content refinement to strengthen relevance and authority",
                        "Technical monitoring to ensure indexing stability",
                        "Structured internal linking to reinforce priority pages"
                    ],
                    closing: "Traffic growth was progressive rather than abrupt. The objective was stable authority development within a competitive beauty market. Over time, the website began receiving consistent organic traffic aligned with purchasing intent."
                }
            },
            {
                id: "managing-algorithm",
                title: "Managing Algorithm Volatility",
                layout: "beige",
                content: {
                    intro: "Throughout the engagement, multiple Google algorithm updates affected the broader e-commerce landscape.",
                    subheading: "During short-term fluctuations:",
                    bullets: [
                        "Rankings experienced temporary adjustments",
                        "Traffic saw minor dips"
                    ],
                    closing: "These were addressed through structured audits, content recalibration, and reinforcement of authority signals. The long-term trend remained upward, with stability restored after each volatility phase."
                }
            },
            {
                id: "media-optimization",
                title: "Social Media Optimization (SMO)",
                layout: "default",
                content: {
                    intro: "To complement search performance, we implemented a structured social media presence designed to:",
                    bullets: [
                        "Strengthen brand recognition",
                        "Support product launches",
                        "Reinforce organic authority signals",
                        "Drive supplementary traffic"
                    ],
                    closing: "This created a balanced acquisition model rather than reliance on a single channel."
                }
            },
        ],
        results: {
            id: "results",
            title: "Reporting & Account Governance",
            content: {
                intro: "Transparency has remained central to the partnership.",
                subheading: "We provide bi-weekly and monthly reports outlining:",
                bullets: [
                    "Keyword ranking progression",
                    "Organic traffic comparisons",
                    "Performance trends across core pages",
                    "Channel-specific movement and insights",
                ],
                bullets2heading: 'A dedicated Project Manager oversees coordination between strategy, execution, and communication, ensuring:',
                bullets2: [
                    "Structured performance review meetings",
                    "Clear reporting explanations",
                    "Timely implementation of updates",
                    "Single-point accountability for the client"
                ],
                closing: "This framework has supported long-term consistency and alignment.",
                chartImage: "/uprivateresult.png"
            }
        },
        imageWithContentLeft: {
            id: "long-term-partnership",
            title: "Performance & Business Impact",
            layout: "image-right",
            content: {
                image: "/uprivateleft.png",
                intro: "",
                subheading: "Over four years of sustained execution:",
                bullets: [
                    "Organic traffic has shown consistent growth patterns",
                    "Keyword visibility strengthened across targeted segments",
                    "The website generates regular orders through SEO",
                    "Search has become a dependable acquisition channel"
                ],
                closing: "Growth has been incremental, stable, and aligned with revenue generation rather than vanity metrics.",
                closingBold: ""
            }
        },
        testimonial: {
            quote: "We are extremely satisfied with the services provided by OMKA TECH for our website, UprivateLabel. Their team delivered a well-structured and high-performing Shopify store that truly reflects our brand identity while ensuring a smooth user experience. Along with development, they executed strong SEO strategies that improved our search visibility and implemented effective SMO techniques that enhanced our social media presence and engagement. The communication was consistent, timelines were respected, and the entire process was handled with professionalism and clarity. We appreciate their strategic approach and consider OMKA TECH a reliable partner in our ongoing e-commerce growth journey.",
            name: "PATRICIA WELLS",
            role: "Business Owner",
            avatar: "/uprivateclient.png"
        }
    },
};

// ── Section renderers ──────────────────────────────────────────
function SectionDefault({ section }) {
    const { content } = section;
    return (
        <div id={section.id} className="seo-section seo-section-default">
            <h2 className="seo-section-title">{section.title}</h2>
            {content.intro && <strong><p className="seo-section-intro">{content.intro}</p></strong>}
            {content.subsections && content?.subsections?.map((sub, i) => (
                <div key={i} className="seo-subsection">
                    <div className="seo-subsection-heading">{sub.heading}</div>
                    <p className="seo-subsection-text">{sub.text}</p>
                </div>
            ))}
            {content.subheading && <p className="seo-section-subheading">{content.subheading}</p>}
            {content.bullets && (
                <ul className="seo-section-bullets">
                    {content?.bullets?.map((b, i) => <li key={i}>{b}</li>)}
                </ul>
            )}
            {content.closing && <p className="seo-section-closing">{content.closing}</p>}
        </div>
    );
}

function SectionBeige({ section }) {
    const { content } = section;
    return (
        <div id={section.id} className="seo-section seo-section-beige">
            <h2 className="seo-section-title">{section.title}</h2>
            {content.intro && <strong><p className="seo-section-intro">{content.intro}</p></strong>}
            {content.subsections && content?.subsections?.map((sub, i) => (
                <div key={i} className="seo-subsection">
                    <div className="seo-subsection-heading">{sub.heading}</div>
                    <p className="seo-subsection-text">{sub.text}</p>
                </div>
            ))}
            {content.subheading && <p className="seo-section-subheading">{content.subheading}</p>}
            {content.bulletheading1 && <p className="seo-section-subheading">{content.bulletheading1}</p>}
            {content.bullets && (
                <ul className="seo-section-bullets">
                    {content?.bullets?.map((b, i) => <li key={i}>{b}</li>)}
                </ul>
            )}
            {content.bulletheading2 && <p className="seo-section-subheading">{content.bulletheading2}</p>}
            {content.bullets2 && (
                <ul className="seo-section-bullets">
                    {content?.bullets2?.map((b, i) => <li key={i}>{b}</li>)}
                </ul>
            )}
            {content.closing && <p className="seo-section-closing">{content.closing}</p>}
        </div>
    );
}

function SectionResults({ cs }) {
    return (
        <div id={cs?.results?.id} className="seo-section seo-section-default section-result">
            {cs.results && <div className="seo-results-grid">
                <div className="seo-results-left">
                    <h2 className="seo-section-title">{cs?.results?.title}</h2>
                    {cs?.results?.content?.intro && <p className="seo-section-intro">{cs?.results?.content?.intro}</p>}
                    {cs?.results?.content?.subheading && <p className="seo-section-subheading">{cs?.results?.content?.subheading}</p>}
                    {cs?.results?.content?.bullets && (
                        <ul className="seo-section-bullets">
                            {cs?.results?.content?.bullets?.map((b, i) => <li key={i}>{b}</li>)}
                        </ul>
                    )}
                    {cs?.results?.content?.bullets2heading && <p className="seo-section-intro">{cs?.results?.content?.bullets2heading}</p>}
                    {cs?.results?.content?.bullets2 && (
                        <ul className="seo-section-bullets">
                            {cs?.results?.content?.bullets2?.map((b, i) => <li key={i}>{b}</li>)}
                        </ul>
                    )}
                    {cs?.results?.content?.closing && <p className="seo-section-closing">{cs?.results?.content?.closing}</p>}
                </div>
                {cs?.results?.content?.chartImage && (
                    <div className="seo-results-chart">
                        {/* FIX 1: loading="eager" + decoding="async" prevents render blocking */}
                        <img
                            src={cs?.results?.content?.chartImage}
                            alt="Results chart"
                            loading="eager"
                            decoding="async"
                            width="600"
                            height="400"
                        />
                    </div>
                )}
            </div>}
        </div>
    );
}

function SectionImageRight({ cs }) {
    return (
        <>
            {cs?.imageWithContentRight && <div id={cs?.imageWithContentRight?.id} className="seo-section seo-section-default right-image">
                <div className="seo-two-col">
                    <div className="seo-two-col-text">
                        <h2 className="seo-section-title">{cs?.imageWithContentRight?.title}</h2>
                        {cs?.imageWithContentRight?.content?.intro && <p className="seo-section-intro">{cs?.imageWithContentRight?.content?.intro}</p>}
                        {cs?.imageWithContentRight?.content?.subheading && <p className="seo-section-subheading">{cs?.imageWithContentRight?.content?.subheading}</p>}
                        {cs?.imageWithContentRight?.content?.bullets && (
                            <ul className="seo-section-bullets">
                                {cs?.imageWithContentRight?.content?.bullets?.map((b, i) => <li key={i}>{b}</li>)}
                            </ul>
                        )}
                        {cs?.imageWithContentRight?.content?.bulletsBottom && <p className="seo-section-subheading">{cs?.imageWithContentRight?.content?.bulletsBottom}</p>}
                        {cs?.imageWithContentRight?.content?.bullet2Heading && <p className="seo-section-subheading">{cs?.imageWithContentRight?.content?.bullet2Heading}</p>}
                        {cs?.imageWithContentRight?.content?.bullets2 && (
                            <ul className="seo-section-bullets">
                                {cs?.imageWithContentRight?.content?.bullets2?.map((b, i) => <li key={i}>{b}</li>)}
                            </ul>
                        )}
                        {cs?.imageWithContentRight?.content?.closing && <p className="seo-section-para">{cs?.imageWithContentRight?.content?.closing}</p>}
                        {cs?.imageWithContentRight?.content?.closingBold && <p className="seo-section-closing">{cs?.imageWithContentRight?.content?.closingBold}</p>}
                    </div>
                    <div className="seo-two-col-img">
                        {/* FIX 2: loading="lazy" for below-fold images saves bandwidth on initial load */}
                        <img
                            src={cs?.imageWithContentRight?.content?.image}
                            alt={cs?.imageWithContentRight?.title}
                            loading="lazy"
                            decoding="async"
                        />
                    </div>
                </div>
            </div>}
        </>
    );
}

function SectionImageLeft({ cs }) {
    return (
        <div id={cs.imageWithContentLeft.id} className="seo-section seo-section-default seo-section-last">
            <div className="seo-two-col seo-two-col-reverse">
                <div className="seo-two-col-text">
                    <h2 className="seo-section-title">{cs.imageWithContentLeft.title}</h2>
                    {cs.imageWithContentLeft.content.paragraphs && cs.imageWithContentLeft?.content?.paragraphs?.map((p, i) => (
                        <p key={i} className="seo-section-para">{p}</p>
                    ))}
                    {cs.imageWithContentLeft.content.subheading && <p className="seo-section-subheading">{cs.imageWithContentLeft.content.subheading}</p>}
                    {cs.imageWithContentLeft.content.bullets && (
                        <ul className="seo-section-bullets">
                            {cs.imageWithContentLeft?.content?.bullets?.map((b, i) => <li key={i}>{b}</li>)}
                        </ul>
                    )}
                    {cs.imageWithContentLeft.content.closing && <p className="seo-section-closing">{cs.imageWithContentLeft.content.closing}</p>}
                </div>
                <div className="seo-two-col-img">
                    {/* FIX 3: loading="lazy" for below-fold images */}
                    <img
                        src={cs.imageWithContentLeft.content.image}
                        alt={cs.imageWithContentLeft.title}
                        loading="lazy"
                        decoding="async"
                    />
                </div>
            </div>
        </div>
    );
}

function SectionRenderer({ section }) {
    switch (section.layout) {
        case 'beige': return <SectionBeige section={section} />;
        default: return <SectionDefault section={section} />;
    }
}

// ── Main component ─────────────────────────────────────────────
export default function SingleSeoCasestudyPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [activeSection, setActiveSection] = useState(0);

    // FIX 4: useRef to store ticking flag — prevents scroll handler from firing
    // on every pixel scroll (requestAnimationFrame throttle)
    const tickingRef = useRef(false);

    const cs = caseStudiesData[id];

    const allSections = [
        ...cs.sections,
        cs.results,
        cs.imageWithContentLeft,
        cs.imageWithContentRight
    ].filter(Boolean);

    // FIX 5: Throttled scroll spy using requestAnimationFrame
    useEffect(() => {
        if (!cs) return;

        const handleScroll = () => {
            if (tickingRef.current) return;
            tickingRef.current = true;

            requestAnimationFrame(() => {
                let current = 0;
                cs.sections.forEach((section, i) => {
                    const el = document.getElementById(section.id);
                    if (el && window.scrollY + 130 >= el.offsetTop) {
                        current = i;
                    }
                });
                setActiveSection(current);
                tickingRef.current = false;
            });
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [cs]);

    // FIX 6: Preload the hero image so it starts fetching immediately,
    // before the component even paints
    useEffect(() => {
        if (!cs?.heroImage) return;
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = cs.heroImage;
        document.head.appendChild(link);
        return () => {
            document.head.removeChild(link);
        };
    }, [cs?.heroImage]);

    const scrollToSection = (sectionId) => {
        const el = document.getElementById(sectionId);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    if (!cs) {
        return (
            <div style={{ padding: '80px 40px', textAlign: 'center' }}>
                <h2>Case study not found.</h2>
                <button onClick={() => navigate('/seo-case-study')} style={{ marginTop: 20 }}>
                    ← Back to Case Studies
                </button>
            </div>
        );
    }

    return (
        <div className="seo-detail-page">
            {/* Hero */}
            <div className="seo-detail-hero">
                {/* FIX 7: fetchpriority="high" + loading="eager" tells browser this is
                    the most important image — paint it FIRST before anything else */}
                <img
                    src={cs.heroImage}
                    alt={cs.heroTitle}
                    fetchpriority="high"
                    loading="eager"
                    decoding="sync"
                />
                <div className="seo-detail-hero-overlay" />
                <div className="seo-detail-hero-text">
                    <h1>{cs.heroTitle}</h1>
                </div>
            </div>

            {/* Overview */}
            <section className="seo-detail-overview">
                <div className="seo-overview-inner">
                    <div className="seo-overview-left">
                        <h2 className="seo-overview-title">{cs.overview.title}</h2>
                        {cs.overview.paragraphs[0].intro ? (<div>
                            <p><strong>{cs.overview.paragraphs[0].intro}</strong></p>
                            <ul>
                                {cs?.overview?.paragraphs[0]?.bullets?.map((b, i) => (
                                    <li key={i}>{b}</li>
                                ))}
                            </ul>
                            <p><strong>{cs?.overview?.paragraphs[0]?.outro}</strong></p>
                        </div>) : (
                            <div className="case-study-text">
                                {cs?.overview?.paragraphs?.map((text, index) => (
                                    <p key={index}>{text}</p>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="seo-overview-meta">
                        <div className="seo-meta-item">
                            <div className="seo-meta-label">{cs.overview.websiteLabel}</div>
                            <div className="seo-meta-value">
                                <a href={cs.overview.websiteHref} target="_blank" rel="noopener noreferrer">
                                    {cs.overview.websiteUrl}
                                </a>
                            </div>
                        </div>
                        <div className="seo-meta-item">
                            <div className="seo-meta-label">INDUSTRY</div>
                            <div className="seo-meta-value">{cs.overview.industry}</div>
                        </div>
                        <div className="seo-meta-item">
                            <div className="seo-meta-label">ENGAGEMENT DURATION</div>
                            <div className="seo-meta-value">{cs.overview.duration}</div>
                        </div>
                        <div className="seo-meta-item">
                            <div className="seo-meta-label">SERVICES</div>
                            <div className="seo-meta-value">{cs.overview.services}</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Keywords Bar */}
            <div className="seo-keywords-bar">
                <div className="seo-keywords-inner">
                    <div className="seo-keywords-label">Top Ranking Keywords:</div>
                    <div className="seo-keywords-text">{cs.overview.topKeywords}</div>
                </div>
            </div>

            {/* Two-Column Content */}
            <div className="seo-detail-content-area">
                <div className="seo-detail-content-inner">

                    {/* Sidebar */}
                    <aside className="seo-detail-sidebar">
                        <div className="seo-sidebar-box">
                            <div className="seo-sidebar-title">SEO Process</div>
                            <ul className="seo-sidebar-nav">
                                {cs?.seoProcess?.map((item, i) => {
                                    const section = allSections[i];
                                    return (
                                        <li key={i}>
                                            <a
                                                href={`#${section?.id}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (section?.id) scrollToSection(section.id);
                                                }}
                                            >
                                                <span className="seo-nav-num">{i + 1}.</span>
                                                {item}
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </aside>

                    {/* Main Content */}
                    <main className="seo-detail-main">
                        {cs?.sections?.map((section) => (
                            <SectionRenderer key={section.id} section={section} />
                        ))}
                    </main>
                </div>
                <SectionResults cs={cs} />
                <SectionImageLeft cs={cs} />
                <SectionImageRight cs={cs} />
            </div>

            {/* Testimonial */}
            {cs.testimonial && (
                <div className="seo-testimonial-wrap">
                    <div className="seo-testimonial-inner">
                        <div className="seo-testimonial-avatar-col">
                            {/* FIX 8: Testimonial avatar is below fold — lazy load it */}
                            <img
                                className="seo-testimonial-avatar"
                                src={cs.testimonial.avatar}
                                alt={cs.testimonial.name}
                                loading="lazy"
                                decoding="async"
                            />
                            <div className="seo-testimonial-name">{cs.testimonial.name}</div>
                            <div className="seo-testimonial-role">{cs.testimonial.role}</div>
                        </div>
                        <div className="seo-testimonial-body">
                            <p className="seo-testimonial-text">
                                {cs.testimonial.quote}
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}